import { render, staticRenderFns } from "./QuestionRespond.vue?vue&type=template&id=ba23fbb4&scoped=true&"
import script from "./QuestionRespond.vue?vue&type=script&lang=js&"
export * from "./QuestionRespond.vue?vue&type=script&lang=js&"
import style0 from "./QuestionRespond.vue?vue&type=style&index=0&id=ba23fbb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba23fbb4",
  null
  
)

export default component.exports